// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__34biP","info":"Note_info__wy8y8","note":"Note_note__rvMxf","actions":"Note_actions__3ZLz9"};